var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/courseList" } },
        [_vm._v("培训课程")]
      ),
      _vm._v(">\n    "),
      _c(
        "a",
        {
          staticClass: "active",
          attrs: { href: "/tjkStudy/courseDetail/" + _vm.test.courseId }
        },
        [_vm._v(_vm._s(_vm.courseName))]
      ),
      _vm._v(">\n    "),
      _c("span", [_vm._v(_vm._s(_vm.test.catalogName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.test.catalogName))]),
          _vm._v(" "),
          _c("component1", { attrs: { poster: _vm.poster, id: "component" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "pdf_viewer" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "catalog" }, [_vm._v("课程目录")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.List, function(lists, key) {
            return _c(
              "li",
              {
                class: { bg: (key + 1) % 2 },
                on: {
                  click: function($event) {
                    return _vm.MaterialDetail(lists.materialId)
                  }
                }
              },
              [
                _c("p", [
                  _vm._v(_vm._s(key + 1) + "、" + _vm._s(lists.catalogName))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    lists.duration != null
                      ? [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.formatSeconds(lists.duration)) +
                              ")"
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "resType",
                      attrs: { src: _vm.img[0].src }
                    })
                  ],
                  2
                )
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32b562d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b562d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/course.vue
// module id = 1110
// module chunks = 0